import React from 'react';

export default function HelpText({field, helpText}) {
  return helpText || field.get('help_text') ? <div className="help-block" style={{marginTop: -5}}>
    {helpText || field.get('help_text')}
  </div> : null;
}
